import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../components/common/page-layout";
import { RequireAuth } from "../../hooks/use-auth";
import { schemaTestListPath } from "../../route-paths";

const styles = {
  form: { maxWidth: 560, mt: 2 },
} satisfies Record<string, SxProps<Theme>>;

/**
 * Entry point for schema test lists. The backend exposes no list query — a test
 * list is looked up strictly by uuid — so this is an id entry that routes to the
 * list's results.
 */
const SchemaTestListsPage = () => {
  const navigate = useNavigate();
  const [listUuid, setListUuid] = useState("");
  const trimmed = listUuid.trim();

  return (
    <RequireAuth>
      <PageLayout
        subtitle="Legacy schema-matching pipeline"
        title="Schema test lists"
      >
        <Typography variant="body2" color="text.secondary">
          Open a schema test list&apos;s results by its uuid. Test lists are
          created from the schema editor.
        </Typography>
        <Box
          component="form"
          sx={styles.form}
          onSubmit={(event) => {
            event.preventDefault();
            if (trimmed.length > 0) {
              navigate(schemaTestListPath(trimmed));
            }
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              fullWidth
              size="small"
              label="Test list uuid"
              value={listUuid}
              onChange={(event) => {
                setListUuid(event.target.value);
              }}
            />
            <Button
              type="submit"
              variant="contained"
              disabled={trimmed.length === 0}
            >
              Open
            </Button>
          </Stack>
        </Box>
      </PageLayout>
    </RequireAuth>
  );
};

export default SchemaTestListsPage;
